import zIndex from "@mui/material/styles/zIndex";

export const tabelStyles = {
    tableTitleStyle:{
        backgroundColor: '#263145',
      color: 'white',
      fontSize:"18px"
      
    },
    tbodyOverFlow:{
      maxHeight:"200px",
      overflowY:"scroll"
    },

    container: {
      width: '96%',
      margin: '0 auto',
    },
    tableContainer: {
      overflowX: 'auto',
      maxWidth: '100%',
      maxHeight:"570px",
      overflowY:"auto",
     
      position: 'relative', zIndex: '10'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      border: '1px solid #dee2e6',
      
     
    },
    headerRow: {
      backgroundColor: '#263145',
      color: 'white',
    },
    normalHeader: {
      padding: '10px',
      minWidth: '120px',
      textAlign: 'center',
      border: '1px solid #dee2e6',
      backgroundColor: 'rgba(229, 229, 229, 0.54)',
      
    },
    expensesHeader: {
      width: '200px',
      padding: '10px',
    //   border: '1px solid #dee2e6',
    },
    headerContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    tableCell: {
      padding: '8px',
      border: '1px solid #dee2e6',
    },
    categoryCell: {
      fontWeight: 'bold',
      padding: '12px 18px',
      border: '1px solid #dee2e6',
    },
    categoryCellContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    valueCell: {
      textAlign: 'right',
      padding: '12px 18px',
      border: '1px solid #dee2e6',
    },
    totalCell: {
      textAlign: 'right',
      fontWeight: 'bold',
     padding: '12px 18px',
      border: '1px solid #dee2e6',
    },
    icon: {
      fontSize: '1.2rem',
    }
  };

export const TopTabStyle = {
    display: 'flex',
    justifyContent: 'end',
    marginBottom:'30%'
}
export const tabStyle = {
    // width: '15%',
    background: 'rgb(219, 233, 255)',
    cursor: 'pointer',
    color: '#000',
    padding: '8px 12px',
    boxShadow: 'inset -3px -3px 10px -7px #000',
    borderTopLeftRadius:'6px',
    borderBottomLeftRadius:'6px',
};
export const activeTabStyle = {
    // width: '15%',
    cursor: 'pointer',
    padding: '8px 15px',
    fontSize:"18px",
    background: '#006c67',
    color: '#fff',
    borderRadius:'6px',
    };
export const h5Style = {
    textAlign: 'center',
    fontSize: '17px',
    margin: '5px 0px',
    writingMode: 'vertical-lr',
    transform:'rotate(180deg)'
}

  export const headerStyle={
    headerContainer:{
      backgroundColor: '#263145',
      color: 'white',
    }
  };

  export const budgetPlanningTrackerStyle={
    budgetPlanningTab:{
      backgroundColor: '#263145',
    }
  };


  export const transactionPopupStyle ={
    label:{
      display:"block",
                marginBottom:"0.5rem",
                color:"#333",
                fontSize:"1.2rem",
                fontWeight:"500"
    },
    dropdownSelect:{
        width:"100%",
                  padding:"0.75rem",
                  border:"1.5px solid #ddd",
                  borderRadius:"6px",
                  fontSize:"1.1rem",
                  backgroundColor:"white",
                  color:"#333",
                  outline:"none",
                  transition:"border-color 0.2s ease"
    }
  }

   export const planningTabsStyle = {
    container: {
      width: "98%",
      margin: "auto",
      padding: "40px 20px",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    tabsWrapper: {
      width: "100%",
      maxWidth: "500px",
      margin: "0 auto",
      background: "linear-gradient(135deg, #006580 0%, #004d5c 100%)",
      borderRadius: "25px",
      padding: "8px",
      // boxShadow: "0px 5px 20px #ccc",
      boxShadow: "0 2px 10px rgba(0, 101, 128, 0.3), 0 2px 10px rgba(0, 101, 128, 0.2)",
      position: "relative",
      overflow: "hidden"
    },
    tabsContainer: {
      display: "flex",
      position: "relative",
      zIndex: 2
    },
    tab: {
      flex: 1,
      padding: "20px 24px",
      textAlign: "center",
      cursor: "pointer",
      borderRadius: "18px",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "relative",
      overflow: "hidden",
      margin: "0 2px",
      userSelect: "none"
    },
    tabActive: {
      backgroundColor: "white",
      color: "#006580",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1)"
    },
    tabInactive: {
      backgroundColor: "transparent",
      color: "white",
      transform: "translateY(0px)"
    },
    tabContent: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      position: "relative",
      zIndex: 1
    },
    tabIcon: {
      fontSize: "18px",
      transition: "transform 0.3s ease"
    },
    tabText: {
      fontWeight: "bold",
      fontSize: "16px",
      letterSpacing: "0.5px",
      transition: "all 0.3s ease"
    },
    shimmer: {
      position: "absolute",
      top: "0",
      left: "-100%",
      width: "100%",
      height: "100%",
      background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
      transition: "left 0.5s ease"
    },
    backgroundGlow: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "200%",
      height: "200%",
      background: "radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)",
      transform: "translate(-50%, -50%)",
      opacity: 0,
      transition: "opacity 0.3s ease",
      pointerEvents: "none"
    }
  };


// export const annualViewTabs = {
//     container: {
//       backgroundColor: '#ffffff',
//     //   minHeight: '100vh',
//       padding: '10px 20px',
//       fontFamily: 'Arial, sans-serif'
//     },
//     tabContainer: {
//     //   maxWidth: '600px',
//       margin: '0 auto',
//       backgroundColor: '#ffffff',
//       borderRadius: '20px',
//       boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
//       overflow: 'hidden'
//     },
//     tabHeader: {
//       position: 'relative',
//       display: 'flex',
//       backgroundColor: '#f8f9fa',
//       borderRadius: '16px',
//       margin: '20px',
//       padding: '6px',
//       boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
//     },
//     tabButton: {
//       flex: 1,
//       padding: '20px 24px',
//       backgroundColor: 'transparent',
//       border: 'none',
//       borderRadius: '12px',
//       cursor: 'pointer',
//       fontSize: '18px',
//       fontWeight: '600',
//       transition: 'all 0.3s ease',
//       position: 'relative',
//       zIndex: 2,
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px'
//     },
//     activeTab: {
//       backgroundColor: '#ffffff',
//       color: '#2563eb',
//       boxShadow: '0 4px 12px rgba(37, 99, 235, 0.15)',
//       transform: 'translateY(-1px)'
//     },
//     inactiveTab: {
//       color: '#6b7280',
//       backgroundColor: 'transparent'
//     },
//     slider: {
//       position: 'absolute',
//       top: '6px',

//       width: 'calc(50% - 6px)',
//       height: 'calc(100% - 12px)',
//       backgroundColor: '#ffffff',
//       borderRadius: '12px',
//       transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//       boxShadow: '0 4px 12px rgba(37, 99, 235, 0.15)',
//       zIndex: 1
//     },
//     contentContainer: {
//       position: 'relative',
//       height: '65vh',
//       overflowY: 'scroll',
//       overflowX:"hidden"
//     },
//     content: {
//       position: 'absolute',
//       top: "0",
//       left: 0,
//       width: '200%',
//       height: '100%',
//       display: 'flex',
      
//       transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
//     },
//     panel: {
//       width: '50%',
//       padding: '40px',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center'
//     },
//     panelIcon: {
//       fontSize: '48px',
//       marginBottom: '24px',
//       color: '#2563eb'
//     },
//     panelTitle: {
//       fontSize: '28px',
//       fontWeight: '700',
//       color: '#1f2937',
//       marginBottom: '16px'
//     },
//     panelDescription: {
//       fontSize: '16px',
//       color: '#6b7280',
//       textAlign: 'center',
//       lineHeight: '1.6',
//       maxWidth: '300px'
//     },
//     slideIndicator: {
//       position: 'absolute',
//       bottom: '20px',
//       left: '50%',
//       transform: 'translateX(-50%)',
//       display: 'flex',
//       gap: '12px',
//       alignItems: 'center',
//       color: '#9ca3af',
//       fontSize: '14px'
//     },
//     arrow: {
//       fontSize: '16px',
//       cursor: 'pointer',
//       padding: '8px',
//       borderRadius: '50%',
//       transition: 'all 0.3s ease',
//       backgroundColor: '#f3f4f6',
//       width: '32px',
//       height: '32px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     },
//     arrowActive: {
//       backgroundColor: '#2563eb',
//       color: '#ffffff',
//       transform: 'scale(1.1)'
//     },
//     arrowDisabled: {
//       opacity: '0.3',
//       cursor: 'not-allowed'
//     }
//   };


// export const annualViewTabs = {
//   container: {
//     backgroundColor: '#ffffff',
//     padding: '10px 20px',
//     fontFamily: 'Arial, sans-serif'
//   },
//   tabContainer: {
//     margin: '0 auto',
//     backgroundColor: '#ffffff',
//     borderRadius: '20px',
//     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden'
//   },
//   tabHeader: {
//     display: 'flex',
//     flexDirection: 'column',
//     backgroundColor: '#f8f9fa',
//     borderRadius: '16px',
//     margin: '20px',
//     padding: '6px',
//     boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
//   },
//   tabButtonContainer: {
//     display: 'flex',
//     width: '100%'
//   },
//   tabButton: {
//     flex: 1,
//     padding: '20px 24px',
//     backgroundColor: 'transparent',
//     border: 'none',
//     borderRadius: '12px',
//     cursor: 'pointer',
//     fontSize: '18px',
//     fontWeight: '600',
//     transition: 'all 0.3s ease',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '8px'
//   },
//   activeTab: {
//     backgroundColor: '#ffffff',
//     color: '#2563eb',
//     boxShadow: '0 4px 12px rgba(37, 99, 235, 0.15)',
//     transform: 'translateY(-1px)'
//   },
//   inactiveTab: {
//     color: '#6b7280',
//     backgroundColor: 'transparent'
//   },
//   contentContainer: {
//     minHeight: '400px',
//     maxHeight: '67vh',
//     overflowY: 'auto',
//     overflowX: 'hidden'
//   },
//   content: {
//     width: '200%',
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'row',
//     transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
//   },
//   panel: {
//     width: '50%',
//     padding: '40px',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     minHeight: '300px'
//   },
//   panelIcon: {
//     fontSize: '48px',
//     marginBottom: '24px',
//     color: '#2563eb'
//   },
//   panelTitle: {
//     fontSize: '28px',
//     fontWeight: '700',
//     color: '#1f2937',
//     marginBottom: '16px'
//   },
//   panelDescription: {
//     fontSize: '16px',
//     color: '#6b7280',
//     textAlign: 'center',
//     lineHeight: '1.6',
//     maxWidth: '300px'
//   },
//   slideIndicator: {
//     bottom: '20px',
//     left: '50%',
//     transform: 'translateX(-50%)',
//     display: 'flex',
//     gap: '12px',
//     alignItems: 'center',
//     color: '#9ca3af',
//     fontSize: '14px'
//   },
//   arrow: {
//     fontSize: '16px',
//     cursor: 'pointer',
//     padding: '8px',
//     borderRadius: '50%',
//     transition: 'all 0.3s ease',
//     backgroundColor: '#f3f4f6',
//     width: '32px',
//     height: '32px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   },
//   arrowActive: {
//     backgroundColor: '#2563eb',
//     color: '#ffffff',
//     transform: 'scale(1.1)'
//   },
//   arrowDisabled: {
//     opacity: '0.3',
//     cursor: 'not-allowed'
//   }
// };




export const annualViewTabs = {
  container: {
    backgroundColor: '#ffffff',
    padding: '10px 20px',
    fontFamily: 'Arial, sans-serif'
  },
  tabContainer: {
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden'
  },
  tabHeader: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f8f9fa',
    borderRadius: '16px',
    margin: '20px',
    padding: '6px',
    boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
  },
  tabButtonContainer: {
    display: 'flex',
    width: '100%'
  },
  tabButton: {
    flex: 1,
    padding: '20px 24px',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  activeTab: {
    backgroundColor: '#ffffff',
    color: '#2563eb',
    boxShadow: '0 4px 12px rgba(37, 99, 235, 0.15)',
    transform: 'translateY(-1px)'
  },
  inactiveTab: {
    color: '#6b7280',
    backgroundColor: 'transparent'
  },
  contentContainer: {
    // minHeight: '400px',
    maxHeight: '67vh',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  content: {
    width: '200%',
    display: 'flex',
    flexDirection: 'row',
    transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    alignItems: 'flex-start'
  },
  panel: {
    width: '50%',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: 'auto'
  },
  panelIcon: {
    fontSize: '48px',
    marginBottom: '24px',
    color: '#2563eb'
  },
  panelTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1f2937',
    marginBottom: '16px'
  },
  panelDescription: {
    fontSize: '16px',
    color: '#6b7280',
    textAlign: 'center',
    lineHeight: '1.6',
    maxWidth: '300px'
  },
  slideIndicator: {
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    color: '#9ca3af',
    fontSize: '14px'
  },
  arrow: {
    fontSize: '16px',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '50%',
    transition: 'all 0.3s ease',
    backgroundColor: '#f3f4f6',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  arrowActive: {
    backgroundColor: '#2563eb',
    color: '#ffffff',
    transform: 'scale(1.1)'
  },
  arrowDisabled: {
    opacity: '0.3',
    cursor: 'not-allowed'
  }
};